var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-slider',{staticClass:"data-range-slider",attrs:{"value":_vm.value,"height":3,"min":_vm.minRange,"disabled":_vm.disabled,"max":_vm.maxRange,"contained":true,"drag-on-click":false,"dot-size":16,"enable-cross":false,"lazy":true,"rail-style":{
  'backgroundColor': '#A1A1A1',
},"process-style":{
  'backgroundColor': '#00AEE8',
}},on:{"dragging":function($event){return _vm.$emit('drag', $event)},"change":function($event){return _vm.$emit('change', $event)}},scopedSlots:_vm._u([{key:"dot",fn:function(){return [_c('div',{staticClass:"data-range-slider__dot"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }